import { render } from "./RIDetails.vue?vue&type=template&id=0f8723e2&scoped=true"
import script from "./RIDetails.vue?vue&type=script&lang=js"
export * from "./RIDetails.vue?vue&type=script&lang=js"

import "./RIDetails.vue?vue&type=style&index=0&id=0f8723e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8723e2"]])

export default __exports__